// #/services/registry/getServiceDetails.ts

import { ServiceDetails } from '#/types/registry';

import getService from './getService';
import serviceDetailsFromService from './openApi/utils/serviceDetailsFromService';

export async function getServiceDetails(
  serviceKey: string,
): Promise<Partial<ServiceDetails> | null> {
  try {
    const service = await getService(serviceKey);

    if (service == null) {
      return null;
    }

    return serviceDetailsFromService(service);
  } catch (error: any) {
    console.error(
      `Error fetching actions for service ${serviceKey}: ${error.message}`,
    );
    // throw new Error(`Error fetching actions for service ${serviceKey}: ${error.message}`);
    return null;
  }
}

export default getServiceDetails;
